class CollapsibleElement extends HTMLElement{connectedCallback(){const title=this.querySelector('.collapsible__title');const content=this.querySelector('.collapsible__content');if(!title||!content)return;

// Initialisation
if(title.getAttribute('active')==='true'){
  content.style.height='auto';
}else{
  title.setAttribute('active','false');
  content.style.height='0px';
}

title?.addEventListener('click',function(e){
  if(title.getAttribute('active')==='true'){
    title.setAttribute('active','false');
    content.setAttribute('active','false');
    content.style.transition='height 0.3s ease';
    content.style.height=content.scrollHeight+'px';
    requestAnimationFrame(()=>{content.style.height='0px'});
    if(title.classList.contains('read-more-link'))title.innerHTML=title.dataset.readMore;
  }else{
    title.setAttribute('active','true');
    content.setAttribute('active','true');
    content.style.transition='height 0.3s ease';
    content.style.height=content.scrollHeight+'px';
    content.addEventListener('transitionend',()=>{content.style.height='auto'},{once:true});
    if(title.classList.contains('read-more-link'))title.innerHTML=title.dataset.readLess;
  }
});

// Resize desktop uniquement
let resizeTimer;
const isDesktop=()=>window.matchMedia('(min-width:768px)').matches;
window.addEventListener('resize',()=>{
  if(!isDesktop())return;
  clearTimeout(resizeTimer);
  resizeTimer=setTimeout(()=>{
    if(title.getAttribute('active')==='true'){
      content.style.transition='none';
      content.style.height=content.scrollHeight+'px';
    }
  },300);
});
}}
customElements.define('collapsible-element',CollapsibleElement)
